import { useEffect } from 'react';
import style from './BackLinksStyle.module.css';

const BackLinks = () => {
  useEffect(() => {
    // Додаємо скрипт для віджета
    const script = document.createElement('script');
    script.src = 'https://widget.clutch.co/static/js/widget.js';
    script.async = true;
    script.onload = () => {
      if (window.CLUTCHCO && typeof window.CLUTCHCO.Init === 'function') {
        window.CLUTCHCO.Init(); // Ініціалізація віджета після завантаження скрипта
      }
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className={style.backLinks}>
      <h2>Our Partners</h2>
      <div className={style.backLinksContainer}>
        {/* Лінк на GoodFirms */}
        <a
          href="https://www.goodfirms.co/"
          target="_blank"
          rel="noopener noreferrer"
          className={style.link}
        >
          GoodFirms
        </a>

        {/* Віджет Clutch */}
        <div
          className="clutch-widget"
          data-url="https://widget.clutch.co"
          data-widget-type="13"
          data-height="50"
          data-nofollow="true"
          data-expandifr="true"
          data-scale="100"
          data-clutchcompany-id="2496148"
        />
      </div>
    </div>
  );
};

export default BackLinks;
